module.exports = __webpack_public_path__ + "static/media/minus-box.203ab15e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/minus-box.svg
// module id = 51
// module chunks = 0